export default "__VITE_ASSET__Cva0yzZW__"